import { useMemo } from 'react';
import { useActiveHouseholdId } from 'src/hooks/use-active-household-id';

import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import type { AccountPeriodReturns } from '../account-performance';
import { ClientPortalNetWorthPerformanceQuery } from '../../../api/net-worth-performance-query';
import { accountPeriodReturns } from '../account-performance';

export type NetWorthPerformanceState = {
  readonly loading: boolean;
  readonly returns: AccountPeriodReturns;
};

const NO_RETURNS: AccountPeriodReturns = {};

export function useNetWorthPerformance(portfolioId: string | undefined, enabled: boolean): NetWorthPerformanceState {
  const { activeHouseholdId, canQuery } = useActiveHouseholdId();
  const skip = !enabled || !canQuery;

  const { data, loading } = useQueryWithErrorLogging(ClientPortalNetWorthPerformanceQuery, {
    variables: { portfolioId, householdId: activeHouseholdId ?? undefined },
    skip,
  });

  const periods = data?.portfolioPerformanceReport.performanceOverTime;
  const returns = useMemo(() => accountPeriodReturns(periods), [periods]);

  return {
    loading: !skip && loading,
    returns: skip ? NO_RETURNS : returns,
  };
}
